import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  inlineFields: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  section: {
    marginBottom: theme.spacing(4),
  },
  headerWithInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  summaryPaper: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    marginBottom: theme.spacing(2),
  },
  stepRow: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  stepOrder: {
    width: 40,
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
  },
  stepContent: {
    flexGrow: 1,
  },
  stepCheckbox: {
    marginLeft: theme.spacing(2),
  },
  infoIcon: {
    cursor: 'help',
    color: theme.palette.action.active,
    fontSize: '1.2rem',
  },
}));

export default useStyles;
